import DimensionWeightsCard from '../assessments/DimensionWeightsCard';
import ThresholdsCard from '../assessments/ThresholdsCard';
import InterpretationLibraryCard from '../assessments/InterpretationLibraryCard';

/**
 * Admin -> Scoring. The three program-wide settings the assessment scoring engine reads.
 * Per-assessment authoring lives in the Assessment Builder, not here.
 */
export const AdminAssessmentScoringTab = () => (
  <div className="space-y-6" data-testid="assessment-scoring-tab">
    <div>
      <h2 className="text-2xl font-bold text-white">Assessment Scoring</h2>
      <p className="text-sm text-gray-400 mt-1 max-w-3xl">
        Program-wide settings shared by all 13 assessments. Questions and their answer weights
        are entered separately in the Assessment Builder.
      </p>
    </div>

    <DimensionWeightsCard />
    <ThresholdsCard />
    <InterpretationLibraryCard />
  </div>
);

export default AdminAssessmentScoringTab;
